import React from 'react';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';

import { FormElementMeta } from '@people-science/forms-core';

import { H3, P } from '../../../../components/Typography';
import Spacer from '../../../../components/Spacer';
import elementIDs from '../../../../../elementIDs';

const StyledQuestion = styled.View<{ isDesktop: boolean }>`
  width: 100%;
`;

const StyledP = styled(P)`
  margin-top: 4px;
`;

const FormElementQuestion: React.FC<{ element: FormElementMeta<any, any> }> = ({
  element
}) => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  return (
    <StyledQuestion testID={elementIDs.elementQuestionID} isDesktop={isDesktop}>
      {Boolean(element.title) && (
        <H3
          testID={elementIDs.elementQuestionTitleID + `-${element.title}`}
          color='dark'
          padding={1}
        >
          {element.title}
        </H3>
      )}
      {Boolean(element.description) && (
        <StyledP
          testID={
            elementIDs.elementQuestionDescriptionID + `-${element.description}`
          }
          color='dark'
        >
          {element.description}
        </StyledP>
      )}
      <Spacer size={2} />
    </StyledQuestion>
  );
};

export default FormElementQuestion;
